import apiService from './api-service'

const withdrawsService = {}

/**
 * Retrieve a withdraws by it's id
 * @param  array params (optional)
 * @return withdraws
 */
withdrawsService.list = function (params) {
  return apiService.get(`/withdraw`, { params }).then(res => res.data)
}

/**
 * Retrieve a withdraws by it's id
 * @param  int id
 * @param  array params (optional)
 * @return withdraws
 */
withdrawsService.getById = function (id, params) {
  return apiService.get(`/withdraw/${id}`, { params }).then(res => res.data)
}

/**
 * Update a withdraws by it's id
 * @param  int id
 * @param  array params (optional)
 * @return withdraws
 */
withdrawsService.updateById = function (id, params) {
  return apiService.put(`/withdraw/${id}`, { params }).then(res => res.data)
}

/**
 * Create a withdraws by it's id
 * @param  object body
 * @return withdraws
 */
withdrawsService.post = function (body) {
  return apiService.post(`/withdraw`, body).then(res => res.data)
}

/**
 * Create a withdraws by it's id
 * @param  object body
 * @return withdraws
 */
withdrawsService.preview = function (body) {
  return apiService.post(`withdraw/preview`, body)
    .then(res => res.data)
}

/**
 * Retrieve withdraw's attachments by it's id
 * @param  object body
 * @return attachments
 */
withdrawsService.getAttachments = function (id, params) {
  return apiService.get(`withdraw/${id}/attachments`, { params })
    .then(res => res.data)
}

/**
 * Confirm a withdraw
 * @param  object body
 * @return attachments
 */
withdrawsService.complete = function (id, body) {
  return apiService.post(`withdraw/${id}/complete`, body)
    .then(res => res.data)
}

/**
 * Cancel a withdraw
 * @param  object body
 * @return attachments
 */
withdrawsService.cancel = function (id, body) {
  return apiService.post(`withdraw/${id}/cancel`, body)
    .then(res => res.data)
}

export default withdrawsService



// WEBPACK FOOTER //
// ./src/services/withdraws.js